import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBU2fn1C0uRDoM3GPhFi9SPDP88MqJcUE8",
  authDomain: "aa-wedding-7a0b8.firebaseapp.com",
  projectId: "aa-wedding-7a0b8",
  storageBucket: "aa-wedding-7a0b8.firebasestorage.app",
  messagingSenderId: "740202880384",
  appId: "1:740202880384:web:b718a6efaadc67342f7565",
  measurementId: "G-ZT3RVJD0NG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

// Initialize Firestore
export const db = getFirestore(app);
